import { Principal } from '@dfinity/principal'
import bigDecimal from 'js-big-decimal'
import { isAddress } from '@solana/kit'

const ACCOUNT_ID_LENGTH = 64
const ALPHANUM_REGEX = /^[a-zA-Z0-9]+$/
const ETH_REGEX = /^(0x)?[0-9a-fA-F]{40}$/
const BTC_ADDRESS_REGEX = /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^[bB][cC]1[pPqQ][a-zA-Z0-9]{38,58}$/
export const CANISTER_MAX_LENGTH = 27

export function sanitizeDecimalInput(amount: string, callback: (value: string) => void) {
  if (!amount || amount.match(/^\d{1,}((\.|\,)\d{0,20})?$/)) {
    callback(amount.replace(',', '.'))
  }
}

export function decimalsToE8s(amount: string, decimals: number = 8) {
  const [wholePart, decimalPart] = amount.split('.')

  const decimalSliced = (decimalPart || '').slice(0, Math.min((decimalPart || '').length, decimals))

  const shifted = `${wholePart === '0' ? '' : wholePart}${decimalSliced}${'0'.repeat(
    Math.max(0, decimals - (decimalPart || '').length)
  )}`
  return shifted.replace(/^0+/, '')
}

export function disableDecimals(amount: string, callback: (value: string) => void) {
  if (!amount || (amount.match(/^\d{1,}?$/) && Number(amount) > 0)) {
    callback(amount)
  }
}

export function getPrettyDecimals(
  amount: bigint | number,
  decimals: number = 8,
  decimalsCount: number = 5
) {
  const decimals_as_e8s = 10 ** decimals
  const value = new bigDecimal(
    Number(Number(amount) / decimals_as_e8s).toFixed(decimalsCount)
  ).getPrettyValue(3, ',')
  return value
}

export function e8sToDecimals(amount: string | number, decimals: number = 8) {
  const decimals_as_e8s = 10 ** decimals
  const normalizedAmount = typeof amount === 'number' ? amount : Number(amount)

  return normalizedAmount / decimals_as_e8s
}

export function validatePrincipal(principal: string) {
  try {
    Principal.fromText(principal)
    return true
  } catch (error) {
    return false
  }
}

export const validateAccountId = (text: string) =>
  text.length === ACCOUNT_ID_LENGTH && ALPHANUM_REGEX.test(text)

export const validateCanisterId = (text: string) => {
  try {
    return text.length <= CANISTER_MAX_LENGTH && validatePrincipal(text)
  } catch (e) {
    return false
  }
}

export const validateEthAddress = (text: string) => ETH_REGEX.test(text)
export const validateBtcAddress = (text: string) => BTC_ADDRESS_REGEX.test(text)
export const validateSolAddress = (text: string) => isAddress(text)
